import React, { useEffect, useState } from 'react'
import {
  DUE_DATE,
  VENDOR,
  DEPARTMENT,
  PARTICULARS,
  PROJECT,
  SUB_PROJECT,
  RELEASING_CENTER,
  SUPPORTING_DOCUMENTS,
  PROJECT_CLASSES,
  REQUEST_TYPE,
  STATUS,
  GROSS_PRICE_PER_ITEM
} from 'types'

import {
  AUTOCOMPLETE_TYPE,
  DATETIME_PICKER_TYPE,
  FILE_INPUT_TYPE,
  INPUT_TYPE,
  SELECT_TYPE
} from '1.newComponents/fields/types'
import RELEASING_CENTERS from 'types/releasingCenter'
import createRequest from 'API/request/postRequest'
import { CRF_CREATION_ENDPOINT } from 'API/endpoints'
import { LABELS, COMPONENTS, GRID, PLACEHOLDERS } from './0.configs'
import CashAdvanceValidateBeforeSubmit, { VALIDATIONS } from './1.validations'
import { loadDepartments, loadVendors, loadProjects } from './dropdownList'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectFormSlice,
  setProgress,
  setCRF
} from '1.newComponents/form/formSlice'
import {
  selectValidationSlice,
  setValidation
} from '1.newComponents/form/validationSlice'
import {
  clearDropdowns,
  selectDropdownListSlice
} from '1.newComponents/form/dropdownListSlice'

const DEFAULT_VALUES = {
  [DUE_DATE]: new Date(),
  [VENDOR]: '',
  [DEPARTMENT]: '',
  [PARTICULARS]: '',
  [PROJECT]: '',
  [SUB_PROJECT]: '',
  [RELEASING_CENTER]: 'BDO Examiner',
  [SUPPORTING_DOCUMENTS]: {},
  [GROSS_PRICE_PER_ITEM]: 0,
  [PROJECT_CLASSES]: [
    {
      glCategory: 'Advances',
      glAccount: '1080-04-03',
      description1: '',
      description2: '',
      itemNumber: '',
      grossPricePerItem: 0,
      netPricePerItem: 0,
      quantity: 1,
      vatType: 'None IVAT-X1',
      vatTypeValue: 1,
      wTax: 0,
      wTaxType: 'X1',
      wTaxRate: '0',
      wTaxTypeValue: 0,
      wTaxTypeString: '',
      unitPrice: 0,
      subNetPrice: 0,
      projectClass: 'Advances to Employee',
      classDepartment: '',
      subTotalGrossPrice: 0.0,
      subTotalNetPrice: 0.0
    }
  ]
}

export default function () {
  const formSlice = useSelector(selectFormSlice)
  const validationSlice = useSelector(selectValidationSlice)
  const dropdownListSlice = useSelector(selectDropdownListSlice)
  const dispatch = useDispatch()
  const [values, setValues] = useState({ ...DEFAULT_VALUES })
  const OPTIONS = {
    [RELEASING_CENTER]: [...RELEASING_CENTERS],
    [VENDOR]: [...dropdownListSlice[VENDOR]],
    [DEPARTMENT]: [...dropdownListSlice[DEPARTMENT]],
    [PROJECT]: [...dropdownListSlice[PROJECT]]
  }

  useEffect(() => {
    loadVendors(dispatch)
    loadDepartments(dispatch)
    loadProjects(dispatch)
    return () => {
      dispatch(clearDropdowns())
    }
  }, [])

  const configData = Object.keys(COMPONENTS).map((key, index) => {
    return {
      label: LABELS[key],
      fieldName: key,
      component: COMPONENTS[key],
      value: values[key],
      placeholder: PLACEHOLDERS[key],
      grid: { ...GRID[key] },
      options:
        COMPONENTS[key] === SELECT_TYPE || COMPONENTS[key] === AUTOCOMPLETE_TYPE
          ? OPTIONS[key]
          : [],
      // this onChange is only for supporting documents since it is not capable of storing file in the redux
      onChange: e => {
        const result = VALIDATIONS[SUPPORTING_DOCUMENTS](e)
        if (!result[0]) {
          dispatch(
            setValidation({
              fieldName: key,
              error: result[0],
              message: result[1]
            })
          )
          setValues({ ...values, [SUPPORTING_DOCUMENTS]: e.target.files[0] })
        } else {
          dispatch(
            setValidation({
              fieldName: key,
              error: result[0],
              message: result[1]
            })
          )
          setValues({ ...values, [SUPPORTING_DOCUMENTS]: {} })
        }
      }
    }
  })

  const updateProgress = progressEvent => {
    const percentCompleted = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    )
    dispatch(setProgress(percentCompleted))
  }

  return {
    configData,
    requestType: 'Cash Advance',
    handleSave: e => {
      //   
    },
    handleCancel: e => {},
    handleSubmit: async () => {
      if (CashAdvanceValidateBeforeSubmit(validationSlice, dispatch)) {
        alert('Please complete the fields first')
      } else {
        dispatch(setProgress(1))
        const formSliceCopy = { ...formSlice }
        const projectClasses = { ...DEFAULT_VALUES[PROJECT_CLASSES][0] }
        projectClasses.description1 = formSlice[PARTICULARS]
        projectClasses[GROSS_PRICE_PER_ITEM] =
          formSliceCopy[GROSS_PRICE_PER_ITEM]
        formSliceCopy[PROJECT_CLASSES] = [{ ...projectClasses }]
        const formData = new FormData()
        formData.append('supportingDocuments', values[SUPPORTING_DOCUMENTS])
        formData.set(
          'crfForm',
          JSON.stringify({ ...formSliceCopy, [REQUEST_TYPE]: 'Cash Advance' })
        )
        const data = await createRequest({
          url: CRF_CREATION_ENDPOINT,
          formData: formData,
          updateProgress: updateProgress
        })
        if (data.statusText === 'Created') {
            
          const { Data } = data.data
          dispatch(setCRF(Data._id))
        }
      }
    },
    handleNext: null
  }
}
